import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService, CentrifugoService, Game } from '@mtgame/core';

export const STORE_GAME_KEY = 'game';

@Injectable()
export abstract class GameRootService extends BaseService {
  private gameId: number;

  get game$(): Observable<Game> {
    return this.store.get(STORE_GAME_KEY);
  }

  protected constructor(
    protected centrifugoService: CentrifugoService,
  ) {
    super();
  }

  async initialize(gameId: number): Promise<Game> {
    this.gameId = gameId;
    this.listenEvents();

    return this.getGame(gameId);
  }

  dispose(): void {
    super.dispose();
    this.centrifugoService.unsubscribe(`game_${this.gameId}`);
  }

  abstract getGame(gameId: number): Promise<Game>;

  getGameModel(): Game {
    return this.store.value(STORE_GAME_KEY);
  }

  protected abstract onGameUpdated(game: Game, oldGame: Game): void;

  private listenEvents(): void {
    const channel = `game_${this.gameId}`;
    this.centrifugoService
      .listen(channel)
      .subscribe(message => {
        switch (message.action) {
          case 'GAME_UPDATED':
          case 'GAME_ARCHIVED':
          case 'GAME_CLOSED': {
            const oldGame = Object.assign(new Game(), this.store.value(STORE_GAME_KEY));
            const newGame = Game.toFront(message.data);
            newGame.gameConfig = oldGame.gameConfig;
            this.onGameUpdated(newGame, oldGame);
            return this.store.save(STORE_GAME_KEY, newGame);
          }

          case 'GAME_SCORE_UPDATED': {
            const newGame = Game.toFront(message.data);
            const game = Object.assign(new Game(), this.store.value(STORE_GAME_KEY));
            game.teamScore = newGame.teamScore;
            game.competitorTeamScore = newGame.competitorTeamScore;
            game.scoreByPeriod = newGame.scoreByPeriod;
            this.store.save(STORE_GAME_KEY, game);
            return;
          }
        }
      });
  }
}
